import React, { useEffect, useRef, useState, useMemo } from "react";
import styles from "./info.module.scss";
import Icon from "../../icons/Icon";
import { ButtonBox } from "../../button/Button";
import ChevrondownG900 from "../../icons/18/ChevrondownG900";
import { v4 as uuidv4 } from "uuid";

export const Info = ({
  isShow = true,
  type = "basic",
  header,
  headerIconName = "",
  toggleEnabled = false,
  contentsData,
  rightAlign = "left",
  listStyle,
  leftWidth = "auto",
  style,
}: {
  isShow?: boolean;
  type?: "basic" | "detail" | "bullet";
  header?: string | React.ReactNode;
  headerIconName?: string;
  toggleEnabled?: boolean;
  contentsData: {
    left?: string | React.ReactNode;
    right?: string | React.ReactNode;
  }[];
  rightAlign?: "left" | "right";
  listStyle?: string;
  leftWidth?: string;
  style?: React.CSSProperties;
}) => {
  const [cardShow, setCardShow] = useState(isShow);
  const openHandler = () => {
    setCardShow((prev) => !prev);
  };

  // 아이콘이 조건에 따라 렌더링 되므로 미리 로드 되도록 처리
  const IconHeaderIconMemo = React.memo(({ name }: { name: string }) => (
    <Icon name={name} size={18} />
  ));
  const IconHeaderIcon = useMemo(
    () => <IconHeaderIconMemo name={headerIconName} />,
    [headerIconName],
  );

  const contentsWithKey = useMemo(() => {
    return contentsData.map((item) => ({
      ...item,
      key: uuidv4(),
    }));
  }, [contentsData]);

  return (
    <>
      {(headerIconName && IconHeaderIcon) ||
        (!headerIconName && (
          <div className={`${styles["info"]} ${styles[type]}`} style={style || {}}>
            {header && (
              <div
                className={`${styles["info-header"]} ${styles["info-header-open"]}`}
                onClick={() => {
                  toggleEnabled && openHandler();
                }}
              >
                {headerIconName && (
                  <div className={styles["info-header-icon"]}>{IconHeaderIcon}</div>
                )}
                <h2 className={styles["info-header-left"]}>{header}</h2>
                {toggleEnabled && (
                  <ButtonBox type="icon">
                    <Icon IconComponent={<ChevrondownG900 />} size={18} />
                  </ButtonBox>
                )}
              </div>
            )}
            {cardShow && (
              <div className={`${styles["info-contents"]}`}>
                <ul className={styles["info-list"]} style={{ listStyleType: listStyle }}>
                  {contentsWithKey.map((content) => (
                    <li
                      key={content.key}
                      className={styles["info-content"]}
                      style={{
                        color: content?.left ? "#737373" : "#191919",
                      }}
                    >
                      {content?.left && (
                        <h3
                          className={styles["info-content-left"]}
                          style={{ width: leftWidth, flexShrink: leftWidth ? 0 : 1 }}
                        >
                          {content.left}
                        </h3>
                      )}
                      {content?.right && (
                        <p
                          className={styles["info-content-right"]}
                          style={{ textAlign: rightAlign }}
                        >
                          {content.right}
                        </p>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        ))}
    </>
  );
};
